import { ConfigProvider, Input, Row, Table, Typography } from "antd"
import PageSidebar from "../common/PageSidebar"
import VSpace from "../common/VSpace"
import { useAllTemplateQueryInvalidator, useAllTemplatesQuery } from "./templateQueries"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRotate } from "@fortawesome/pro-solid-svg-icons"
import SidebarCreateButton from "../common/SidebarCreateButton"
import { grey, red } from "@ant-design/colors"
import ThemableButton from "../Items/ThemableButton"
import { useState } from "react"
import { filterTemplates } from "./templateModel"

const { Text } = Typography

type Props = {
  showDeletedView: boolean
  selectedTemplateId?: number
  onTemplateSelect: (templateId: number) => void
}

const TemplatesSidebar = ({showDeletedView, selectedTemplateId, onTemplateSelect}: Props) => {
  const allTemplatesQuery = useAllTemplatesQuery(showDeletedView)
  const invalidator = useAllTemplateQueryInvalidator()
  const [search, setSearch] = useState('')
  
  const filteredTemplates = filterTemplates(allTemplatesQuery.data ?? [], search)

  return <PageSidebar>
    <VSpace size="large">
      <VSpace style={{padding: '10px 10px 0 10px'}}>
        <Row justify="space-between" align="middle">
          <Text style={{ color: 'white', fontSize: 18, fontFamily: 'Open Sans, sans-serif'}}>{showDeletedView ? 'DELETED ' : ''}Templates</Text>
          <ThemableButton type="link" colorLink={grey[2]} icon={<FontAwesomeIcon icon={faRotate} />} onClick={() => invalidator.invalidate()} />
        </Row>
        <Row>
          <Input.Search placeholder="Search" value={search} onChange={x => setSearch(x.target.value ?? '')} allowClear />
        </Row>
      </VSpace>
      
      {!showDeletedView && <SidebarCreateButton text="Create New Template" onClick={() => onTemplateSelect(0)} /> }

      <div className="react-scrollable-list" style={{
        height: `calc(100vh - ${showDeletedView ? '110px' : '192px'})`
      }}>
        <ConfigProvider theme={{
          components: {
            Table: {
              colorBgContainer: '#3d587f',
              borderColor: '#3d587f',
              rowHoverBg: '#4a6b9a',
              colorText: 'white'
            }
          }
        }}>
          <Table
            size="small"
            pagination={false}
            dataSource={filteredTemplates}
            loading={allTemplatesQuery.isFetching}
            showHeader={false}
            rowKey={x => x.id}
            onRow={(template) => {
              return {
                style: {
                  cursor: 'pointer',
                  backgroundColor: selectedTemplateId === template.id ? '#4a6b9a' : undefined,
                  color: showDeletedView ? red.primary : undefined
                },
                onClick: () => onTemplateSelect(template.id)
              }
            
            }}
            columns={[
              {
                render: (_, template) => <>
                  <div>{template.name}</div>
                  <small style={{color: '#fafafa80'}}>{template.categories}</small>
                </>
              }
            ]}
          />
        </ConfigProvider>
      </div>
    </VSpace>
  </PageSidebar>
}

export default TemplatesSidebar